@if (hasCustomerCare) {
    <div class="PGCustomerCareSettings px-3 py-2" [class.PGCustomerCareSettings--EditOpen]="isEditOpen">
        @if (isLoadingProfile) {
            <app-pg-loading></app-pg-loading>
        }
        @if (!isLoadingProfile) {
            <div class="PGCustomerCareSettings-Bar">
                <div class="PGCustomerCareSettings-Bar-Toolbar">
                    <div class="PGCustomerCareSettings-Bar-Left">
                        <span class="PGCustomerCareSettings-Label">{{ 'pg-user-menu.customer-care' | locTranslate }}</span>
                        <app-pg-switch [small]="true" [readonly]="!canSetCustomerCare()" [ngModel]="getUserCustomerCare()" (ngModelChange)="setUserCustomerCare($event)"></app-pg-switch>
                    </div>
                </div>
                <div class="PGCustomerCareSettings-Bar-Preview text-muted border-top">
                    @if (getUserCustomerCare()) {
                        @if (isLoadingAvailability) {
                            <app-pg-loading></app-pg-loading>
                        }
                        @if (!isLoadingAvailability) {
                            <div class="PGCustomerCareSettings-Bar-Preview-Row">
                                <div class="PGCustomerCareSettings-Bar-Preview-Meta">
                                    <span class="PGCustomerCareSettings-Bar-Preview-Item" [title]="getLanguagesPreview()">{{ getLanguagesPreview() }}</span>
                                    <span class="PGCustomerCareSettings-Bar-Preview-Sep">·</span>
                                    <span class="PGCustomerCareSettings-Bar-Preview-Item" [title]="getChannelsPreview()">{{ getChannelsPreview() }}</span>
                                </div>
                                <div class="PGCustomerCareSettings-Bar-Right">
                                    <button type="button" class="btn btn-white btn-sm" [disabled]="!getUserCustomerCare()" [class.active]="isEditOpen" [title]="'pg-user-menu.customer-care-edit' | locTranslate" (click)="toggleEditPanel()">
                                        <i class="fa-regular fa-{{ isEditOpen ? 'times' : 'edit' }}"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="PGCustomerCareSettings-Bar-Preview-Availability" [innerHTML]="getAvailabilityPreview()"></div>
                        }
                    }
                    @if (!getUserCustomerCare()) {
                        <div class="PGCustomerCareSettings-Bar-Preview-Row">
                            <span>{{ 'pg-user-menu.customer-care-inactive' | locTranslate }}</span>
                            <div class="PGCustomerCareSettings-Bar-Right">
                                <button type="button" class="btn btn-white btn-sm" [disabled]="true" [title]="'pg-user-menu.customer-care-edit' | locTranslate">
                                    <i class="fa-regular fa-edit"></i>
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
            @if (isEditOpen && getUserCustomerCare()) {
                <div class="PGCustomerCareSettings-Panel border-top">
                    @if (isLoadingAvailability || isSettingCustomerCare) {
                        <app-pg-loading [isOverlay]="isSettingCustomerCare"></app-pg-loading>
                    }
                    <div class="row PGCustomerCareSettings-Panel-Section">
                        <div class="col-6">
                            <div class="PGCustomerCareSettings-Panel-Label">
                                <b>{{ 'pg-user-menu.customer-care-languages' | locTranslate }}</b>
                            </div>
                            <app-pg-select [multi]="true" [readonly]="!canSetCustomerCare()" [ngModel]="getUserCustomerCareLanguages()" (ngModelChange)="setUserCustomerCareLanguages($event)" [options]="customerCareLanguageOptions" display="oneLine"></app-pg-select>
                        </div>
                        <div class="col-6">
                            <div class="PGCustomerCareSettings-Panel-Label">
                                <b>{{ 'pg-user-menu.customer-care-channels' | locTranslate }}</b>
                            </div>
                            <app-pg-select [multi]="true" [readonly]="!canSetCustomerCare()" [ngModel]="getUserCustomerCareChannels()" (ngModelChange)="setUserCustomerCareChannels($event)" [options]="customerCareChannelOptions" display="oneLine"></app-pg-select>
                        </div>
                    </div>
                    <div class="PGCustomerCareSettings-Panel-Section PGCustomerCareSettings-Panel-Section--Availability">
                        <div class="PGCustomerCareSettings-Panel-Label">
                            <b>{{ 'pg-user-menu.customer-care-availability' | locTranslate }}</b>
                        </div>
                        <div class="PGCustomerCareSettings-Panel-Editor">
                            <app-pg-timetable-editor timetableMode="openings" [ngModel]="editAvailability" (ngModelChange)="setUserAvailabilitySlots($event)" [multi]="true"></app-pg-timetable-editor>
                        </div>
                    </div>
                </div>
            }
        }
    </div>
}
